export default __webpack_public_path__ + "static/media/header.503be924.png";